import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { TextField } from '../../../ui/FormElement';

function SessionsCovered(props) {
  const { isDisabled, ...rest } = props;
  const {
    values: { sessions_covered_enable },
    setFieldValue,
  } = useFormikContext();

  // useEffect(() => {
  //  if (cover_everybody) {
  // setFieldValue("employees_covered", total_employees);
  //  }
  // }, [cover_everybody]);

  return (
    <TextField
      disabled={!sessions_covered_enable || isDisabled}
      name="sessions_covered"
      type="number"
      step="1"
      pattern="[0-9]*"
      {...rest}
    />
  );
}

export default SessionsCovered;
